// The Connections screen's URL search: the focus as one id, never text (docs/CONTRACTS.md section 5). `focus` is an
// organisation number (the explorer's own parameter, so its link opens here), `person` a register person id and
// `contact` one of the viewer's contacts. No imports but types, so the route entry (loaded with the shell) stays small.

export interface ConnectionsSearch {
  /** 9-digit organisation number, kept as a number (the router writes a digits-only string quoted); no leading zero exists */
  focus?: number
  person?: string
  contact?: string
}

/** Router validateSearch: at most one focus; an organisation number wins over a person, a person over a contact. */
export function parseSearch(search: Record<string, unknown>): ConnectionsSearch {
  const raw = typeof search.focus === 'number' ? String(search.focus) : search.focus
  if (typeof raw === 'string' && /^[1-9]\d{8}$/.test(raw)) return { focus: Number(raw) }
  if (typeof search.person === 'string' && /^p_[0-9a-f]{32}$/.test(search.person)) return { person: search.person }
  if (typeof search.contact === 'string' && /^[A-Za-z0-9_.-]{1,128}$/.test(search.contact)) return { contact: search.contact }
  return {}
}

/** The focus as graph.ego takes it. */
export function focusOf(s: ConnectionsSearch): { orgnr?: string; personId?: string; contactId?: string } | null {
  if (s.focus !== undefined) return { orgnr: String(s.focus) }
  if (s.person) return { personId: s.person }
  if (s.contact) return { contactId: s.contact }
  return null
}

/** A node key as a URL search. */
export function searchOfKey(key: string): ConnectionsSearch {
  const id = key.slice(key.indexOf(':') + 1)
  if (key.startsWith('org:')) return { focus: Number(id) }
  if (key.startsWith('person:')) return { person: id }
  if (key.startsWith('contact:')) return { contact: id }
  return {}
}
